import React from 'react';
import Component from './Component';
import {TextInput as BaseInput} from 'reactis-forms';
import classNames from 'classnames'
import Glyphicon from './Glyphicon';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

class TextInput extends React.Component {

	static filterDelay  = true;

	getError() {
		return this.props.error && this.props.error[0];
	}

	renderInputGroup(children) {
		let addonBefore = this.props.addonBefore ? (
			<span className="input-group-addon" key="addonBefore">
        		{this.props.addonBefore}
      		</span>
		) : null;

		let addonAfter = this.props.addonAfter ? (
			<span className="input-group-addon" key="addonAfter">
      		  {this.props.addonAfter}
      		</span>
		) : null;

		let buttonBefore = this.props.buttonBefore ? (
			<span className="input-group-btn">
        		{this.props.buttonBefore}
      		</span>
		) : null;

		let buttonAfter = this.props.buttonAfter ? (
			<span className="input-group-btn">
        		{this.props.buttonAfter}
      		</span>
		) : null;

		let inputGroupClassName;
		switch (this.props.bsSize) {
			case 'small':
				inputGroupClassName = 'input-group-sm';
				break;
			case 'large':
				inputGroupClassName = 'input-group-lg';
				break;
			default:
		}

		const tooltip = this.props.help ? <Tooltip id={this.props.help}>{this.props.help}</Tooltip> : null;
		const help = this.props.help ? <span className="input-group-addon inputhelp" key="addonHelp">
						<OverlayTrigger placement='top' overlay={tooltip}><span className="fa fa-question-circle"></span></OverlayTrigger>
					</span> : null;

		return addonBefore || addonAfter || buttonBefore || buttonAfter || help || this.props.notice? (
			<div className={classNames(inputGroupClassName, 'input-group')} key="input-group">
				{addonBefore}
				{buttonBefore}
				{children}
				{addonAfter}
				{buttonAfter}
				{help}
				{this.props.notice}
			</div>
		) : children;
	}

	renderIcon() {
		if (this.props.hasFeedback) {
			if (this.props.feedbackIcon) {
				return React.cloneElement(this.props.feedbackIcon, {formControlFeedback: true});
			}

			switch (this.props.bsStyle) {
				case 'success':
					return <Glyphicon formControlFeedback glyph="ok" key="icon"/>;
				case 'warning':
					return <Glyphicon formControlFeedback glyph="warning-sign" key="icon"/>;
				case 'error':
					return <Glyphicon formControlFeedback glyph="remove" key="icon"/>;
				default:
					return <span className="form-control-feedback" key="icon"/>;
			}
		} else {
			return null;
		}
	}

	renderWrapper(children) {

		const classes = {
			'has-error': this.getError()
		};

		return <span className={classNames(classes, this.props.wrapperClassName)} key="wrapper">
				{children}
			</span>
	}

	renderLabel(children) {
		let classes = {
			'control-label': false
		};
		classes[this.props.labelClassName] = this.props.labelClassName;

		return this.props.label ? (
			<label htmlFor={this.props.id} className={classNames(classes)} key="label">
				{children}
				{this.props.label}
			</label>
		) : children;
	}

	handleReset(e) {
		e.stopPropagation();
		if (this.props.onChange) {
			this.props.onChange(null);
		}
		if (this.props.onBlur) {
			this.props.onBlur(null);
		}
	}

	renderInput() {

		const className = 'form-control';
		const {clearable} = {...this.props};
		if (clearable) {
			return <div key="inputw" style={{position:'relative'}}>
				{this.props.value && <span style={{right: this.props.showPicker ? 26 : 8}} className="inputreset icon-cross" onClick={e => this.handleReset(e)}></span>}
				{this.props.showPicker && this.props.onPickClick && <span style={{right: 8, color: '#666'}} onClick={(e) => this.props.onPickClick()} className="inputreset fa fa-hand-pointer-o"></span>}
				<BaseInput ref="input" {...this.props} style={{...this.props.style, paddingRight: this.props.showPicker ? 40 : 24}} className={classNames(this.props.className, className)} key="input"/>
			</div>;
		}
		return <BaseInput ref="input" {...this.props} className={classNames(this.props.className, className)} key="input"/>
	}

	renderError() {
		const error = this.getError();
		return error ? (
			<span className="error-block" key="error">{error}</span>
		) : null;
	}

	renderChildren() {
		return [
			//this.renderLabel(),
			this.renderWrapper([
				this.renderInputGroup(
					this.renderInput()
				),
				this.renderIcon(),
				this.renderError()
			])
		];
	}

	focus() {
		this.refs.input.focus();
	}

	render() {
		let children = this.renderChildren();
		return <span>{children}</span>;
	}
}

TextInput.propTypes = {
	type: React.PropTypes.string,
	label: React.PropTypes.node,
	help: React.PropTypes.node,
	addonBefore: React.PropTypes.node,
	addonAfter: React.PropTypes.node,
	buttonBefore: React.PropTypes.node,
	buttonAfter: React.PropTypes.node,
	bsSize: React.PropTypes.oneOf(['small', 'medium', 'large']),
	bsStyle: React.PropTypes.oneOf(['success', 'warning', 'error']),
	hasFeedback: React.PropTypes.bool,
	feedbackIcon: React.PropTypes.node,
	id: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.number
	]),
	groupClassName: React.PropTypes.string,
	wrapperClassName: React.PropTypes.string,
	labelClassName: React.PropTypes.string,
	disabled: React.PropTypes.bool,
	value: React.PropTypes.any
};

TextInput.defaultProps = {
	type: 'text',
	disabled: false,
	hasFeedback: false
};

export default TextInput;


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/TextInput.js